namespace e5.TransformMode {
    class TransformModeInject implements ITransformMode {
        private _elements: HTMLDivElement[] = [];
        private _quad: Quad = new Quad();
        private _matrix = new Matrix2d();

        constructor() {
            for (var i = 0; i < 4; ++i) {
                var div = document.createElement("div");
                div.style.position = "absolute";
                div.style.left = "0";
                div.style.top = "0";
                div.style.transformOrigin = "0 0";
                this._elements.push(div);

                // div.style.backgroundColor = "#000";
                // div.style.marginLeft = "-5px";
                // div.style.marginTop = "-5px";
                // div.style.width = "10px";
                // div.style.height = "10px";
                // div.style.borderRadius = "50%";
            }
        }

        public extract(transform: Transform, matrix: Matrix3d): void {
            var element = transform.element;
            var style = transform.style;

            var borderTop = Calc.parse(style.borderTopWidth, 0);
            var borderLeft = Calc.parse(style.borderLeftWidth, 0);
            borderLeft -= element.scrollLeft;
            borderTop -= element.scrollTop;

            //TODO: is this really working???
            //If the element width/height is set to 0 than this is a good solution.
            var elementWidth = 1000;//element.offsetWidth;
            var elementHeight = 1000;//element.offsetHeight;

            var left = -borderLeft;
            var top = -borderTop;
            //That is very strange???? why subtracting only the left- and top-border???
            var right = elementWidth - borderLeft;
            var bottom = elementHeight - borderTop;

            //Move the divs to the outer corners.
            this._elements[0].style.transform = "translate(" + left + "px, " + top + "px)";
            this._elements[1].style.transform = "translate(" + right + "px, " + top + "px)";
            this._elements[2].style.transform = "translate(" + right + "px, " + bottom + "px)";
            this._elements[3].style.transform = "translate(" + left + "px, " + bottom + "px)";

            //Inject the divs to the target element.
            this.inject(transform.element);

            //Apply the bounding-rect positions to the quad points.
            for (var i = 0; i < 4; ++i) {
                var r = this._elements[i].getBoundingClientRect();
                var pt = this._quad.points[i];
                pt.x = r.left;
                pt.y = r.top;
            }

            //Remove the divs from the target element.
            this.reject();

            var ma = MatrixFit.fromQuad({ x: 0, y: 0 }, elementWidth, elementHeight, this._quad, this._matrix);
            matrix.setData(ma.getData(9));
        }

        private inject(element: HTMLElement): void {
            for (var div of this._elements) {
                element.appendChild(div);
            }
        }

        private reject(): void {
            // return;
            for (var div of this._elements) {
                if (div.parentElement)
                    div.parentElement.removeChild(div);
            }
        }
    }

    export const Inject = new TransformModeInject();
}